export const MESSAGE_PRICE_TOKEN_OPTIONS: number[] = [5, 6, 7, 8, 9, 10];